import { render, staticRenderFns } from "./SingleCandidate.vue?vue&type=template&id=856dafbe&scoped=true"
import script from "./SingleCandidate.vue?vue&type=script&lang=ts"
export * from "./SingleCandidate.vue?vue&type=script&lang=ts"
import style0 from "./SingleCandidate.vue?vue&type=style&index=0&id=856dafbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856dafbe",
  null
  
)

export default component.exports